import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const NannyJobsDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Nanny Jobs'
    directoryProvider={PROVIDERS.NANNIES}
    directoryBasePath={PROVIDERS.NANNIES.jobsBasePath}
    directoryResultsType={RESULTS_TYPES.JOBS}
  />
)

export default NannyJobsDirectories
